import type React from "react";
import { ReactComponent as Svg } from "./assets/icon-pick.svg";
import * as styles from "./Icon.module.scss";

type PickProps = React.SVGProps<SVGSVGElement>;

export const Pick = ({ className, ...props }: PickProps) => (
  <Svg className={className ?? styles.base} {...props} />
);
